import { Helmet } from 'react-helmet';
import Footer from '../../components/light/modern-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import Navbar from '../../components/light/creative-agency/Navbar';
import Testimonials from '../../components/light/FAQS/Testimonials';
import Header from '../../components/light/services/Header';
import Services from '../../components/light/services/Services';
import Marquee from '../../components/light/services/Marquee';
import Price from '../../components/light/services/Price';
import Process from '../../components/light/services/Process';
import Blog from '../../components/light/services/Blog';
export default function LPageServices() {
  return (
    <>
      <Helmet>
        <title>Our Programmes | SPOB Nigeria</title>
        <meta name="description" content="Explore SPOB Nigeria's flagship programmes spanning health, education, culture, environment and youth vocational development across South West Nigeria." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://spob-nigeria.vercel.app/light/services" />
        <meta property="og:title" content="Our Programmes | SPOB Nigeria" />
        <meta property="og:description" content="Explore SPOB Nigeria's flagship programmes spanning health, education, culture, environment and youth vocational development across South West Nigeria." />
        <meta property="og:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-4.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Programmes | SPOB Nigeria" />
        <meta name="twitter:description" content="Explore SPOB Nigeria's flagship programmes spanning health, education, culture, environment and youth vocational development." />
        <meta name="twitter:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-4.jpg" />
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <Services />
              <Marquee />
              <Price />
              <Testimonials />
              <Process />
              <Blog />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
